<template>
  <i :class="[handle(), 'cursor-pointer text-[0.8em]']" @click="changeState()" />
  {{ value }}
</template>

<script setup>
import { ref, watch } from 'vue'

const emits = defineEmits(['update:modelValue'])
const props = defineProps({
  value: { type: Number, default: 0 },
})

const localValue = ref(props.value ?? 0)

const changeState = () => {
  if (localValue.value < 2) {
    localValue.value++
    emits('update:modelValue', localValue.value)
  } else {
    localValue.value = 0
    emits('update:modelValue', 0)
  }
}

const handle = () => {
  if (localValue.value == 2) {
    return ' fa-solid fa-sort-up '
  } else if (localValue.value == 1) {
    return ' fa-solid fa-sort-down '
  }
  return ' fa-solid fa-sort'
}

watch(
  () => props.value,
  () => {
    localValue.value = props.value
  },
  { deep: true }
)
</script>
